import Loadable from 'react-loadable'

const searchParamLoadable = Loadable({
  loader: () => import('./SearchParam'),
  loading: () => null,
})

export default searchParamLoadable
